/* tslint:disable*/
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { mergeMap, take } from 'rxjs/operators';
import { NotificationTokenInput } from '../../models/lead/notificationTokenInput';
import { NotificationService } from '../notification/notification.service';

@Injectable()
export class MessagingService {

  // tslint:disable-next-line: rx-subject-restrictions
  currentMessage$ = new BehaviorSubject(null);

  constructor(
    private readonly notificationService: NotificationService,
    private readonly angularFireAuth: AngularFireAuth,
    private readonly angularFireMessaging: AngularFireMessaging
  ) {

  }

  init(): void {
    this.angularFireMessaging.messaging.subscribe(_messaging => {
      _messaging.onMessage = _messaging.onMessage.bind(_messaging);
      _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);

      navigator.serviceWorker
        .ready
        .then(registration => {
          try {

            _messaging.useServiceWorker(registration);
          } catch (e) {

            if (e.code === 'messaging/use-sw-before-get-token') {
              // Silenced error because, this code is asynchronous
            } else {

              throw e;
            }
          }
        });
    }
    );
  }

 async updateToken(token: string) {
    // we can change this function to request our backend service
    this.angularFireAuth.authState.pipe(take(1))
      .subscribe(
        () => {
          const input: NotificationTokenInput = new NotificationTokenInput();
          input.token = token;
          this.notificationService.saveNotificationToken$(input);
        });
  }

  requestPermission(): void {
    this.angularFireMessaging.requestToken.subscribe(async token => {
      await this.updateToken(token);
    }, err => {
      throw new Error('Unable to get permission to notify.' + err);
    }
    );
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage(): void {
    this.angularFireMessaging.messages.subscribe(payload => {
      this.currentMessage$.next(payload);
    });
  }

  deleteToken(): void {

    this.notificationService.deleteNotificationToken$()

    // TODO review and fix error 404 Requested entity not was found
    // this.angularFireMessaging.getToken
    //   .pipe(mergeMap(token => this.angularFireMessaging.deleteToken(token)))
    //   .subscribe(
    //     () => { console.dir('Token deleted...'); }
    //   );
    // this.angularFireAuth.auth.signOut()
    //   .then(() => {
    //     console.dir('fcm logout');
    //   });
  }
}
